import { useRef, useState } from 'react';
import { useAuthData } from 'api/auth/useAuthData';
import { queryCache, queryClient } from 'core';
import { getBrowserStorage } from 'plugins/localForage';
import useDeviceSize from 'utils/hooks/useDeviseSize';
import { useRouter } from 'next/router';
import { apiGetAccessToken } from 'api/auth/apiGetAccessToken';
import { redirectPath } from 'utils/hooks/UseRedireckPath';
import { QUERY_KEY_AUTH_DATA, apiGetAuthData } from 'api/auth/apiGetAuthData';

export const useHeader = ({ _identity = '' }) => {
  const mainStorage = getBrowserStorage();
  const { id: authUserId, refetch } = useAuthData();
  const node = useRef(null);

  const router = useRouter();

  const [isMenuOpen, setMenuOpen] = useState(false);

  const [hadIdentity] = useState(!!_identity?.length);

  const checkAuthApi = async (userToken: string | any[]) => {
    if (userToken && userToken?.length) {
      await mainStorage.setItem('auth_key', userToken);
      await queryClient.cancelQueries();
      await queryCache.clear();
      await refetch();
    }
  };

  const checkAuth = async (userIdenty: string) => {
    const userToken = await apiGetAccessToken();

    if (userIdenty && userIdenty.length > 0) {
      const authArray = JSON?.parse(userIdenty);
      const [userId, userKey = ''] = authArray;
      const userKeyWithoutQuotes = userKey === null ? '' : userKey.replace(/["']/g, '');

      if (authUserId !== userId) {
        await mainStorage.setItem('auth_key', userKeyWithoutQuotes);
        await queryClient.cancelQueries();
        await queryCache.clear();
        await refetch();
      }
    } else if (userToken.auth_key.length > 0) {
      checkAuthApi(userToken.auth_key);
    } else {
      const getAuthKey = await mainStorage.getItem('auth_key');
      if (!hadIdentity && userToken.auth_key.length === 0 && getAuthKey?.length > 0) {
        await mainStorage.removeItem('auth_key');
        await queryClient.cancelQueries();
        await queryCache.clear();
        router.reload();
      }
    }
  };

  const {
    query: { auth_key = '' },
  } = router;

  const linkToRedirect = redirectPath();

  const linkToReplace = linkToRedirect.split('?')[0];

  const checkToken = async (auth_key: string | any[]) => {
    if (typeof auth_key === 'string' && auth_key.length >= 6) {
      await mainStorage.setItem('auth_key', auth_key);
      await queryClient.invalidateQueries([QUERY_KEY_AUTH_DATA, {}]);
      await apiGetAuthData();
      await router.replace(`${linkToReplace}`);
    }
  };

  const deviceSizes = useDeviceSize();

  const deviceWidth = deviceSizes[0];

  return {
    node,
    checkAuth,
    checkToken,
    auth_key,
    authUserId,
    isMenuOpen,
    deviceWidth,
    setMenuOpen,
  };
};
